import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { Grid } from 'components/grid';
import PropTypes from 'prop-types';

import FileSectionContent from './FileSectionContent';
import FileSectionHeader from './FileSectionHeader';

import './FileSection.scss';

export default class FileSection extends PureComponent {
  static Header = FileSectionHeader;
  static Content = FileSectionContent;

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    slim: PropTypes.bool
  };

  render() {
    const { className, children, slim } = this.props;

    const classComponent = classNames('file__section _mb-2', className);

    return (
      <Grid
        block
        nomargin
        nopadding={slim}
        noborder={slim}
        className={classComponent}
        data-test="media-card"
      >
        {children}
      </Grid>
    );
  }
}
